import React, { Fragment } from "react";
import { TickRenderer } from "../../../../libraries/ReportGenerator/TickRenderer";
import { getTotalMiles } from "../../utils/getTotalMiles";

const LocationOptions = {
  West: "West",
  East: "East",
  Both: "Both",
};

export const ONR_WeedSprayingRequirementsSchema = {
  sections: [
    {
      heights: {
        header1: "auto",
        header2: "auto",
      },
      minDataRowsCount: 10,
      columns: [
        {
          title: "Mileage",
          colSpan: 4,
          rowSpan: 1,
          className: "tbl-text-normal",
          columns: [
            {
              title: "From",
              colSpan: 2,
              rowSpan: 1,
              className: "tbl-text-normal",
              accessor: "from",
            },
            {
              title: "To",
              colSpan: 2,
              rowSpan: 1,
              className: "tbl-text-normal",
              accessor: "to",
            },
          ],
        },
        {
          title: "Total Miles",
          colSpan: 2,
          rowSpan: 2,
          className: "tbl-text-normal",
          accessor: ["from", "to"],
          dontJoinValues: true,
          formatter: getTotalMiles,
        },
        {
          title: "Location Description",
          colSpan: 6,
          rowSpan: 1,
          className: "tbl-text-normal",
          columns: [
            {
              title: "East",
              colSpan: 2,
              rowSpan: 1,
              className: "tbl-text-normal",
              accessor: "loc",
              formatter: (val) => TickRenderer(val, LocationOptions.East),
            },
            {
              title: "West",
              colSpan: 2,
              rowSpan: 1,
              className: "tbl-text-normal",
              accessor: "loc",
              formatter: (val) => TickRenderer(val, LocationOptions.West),
            },
            {
              title: "Both",
              colSpan: 2,
              rowSpan: 1,
              className: "tbl-text-normal",
              accessor: "loc",
              formatter: (val) => TickRenderer(val, LocationOptions.Both),
            },
          ],
        },
        {
          title: "Remarks",
          colSpan: 8,
          rowSpan: 2,
          className: "tbl-text-normal",
          accessor: "com",
        },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/components/Reports/ONR/WeedSprayingRequirements/ONR_WeedSprayingRequirementsSchema.js